import { useRef } from 'react'

export default function useNoRenderRef(currentValue) {
	const ref = useRef(currentValue);
	ref.current = currentValue;
	return ref;
}